import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "vi", "ko", "ja", "zh"] as const,
  defaultLocale: "en",
  localeDetection: true,
  localePrefix: "always",
});

export type AppLocale = (typeof routing.locales)[number];

export const localeMeta: Record<AppLocale, { label: string; native: string; flag: string }> = {
  en: { label: "English", native: "English", flag: "🇺🇸" },
  vi: { label: "Vietnamese", native: "Tiếng Việt", flag: "🇻🇳" },
  ko: { label: "Korean", native: "한국어", flag: "🇰🇷" },
  ja: { label: "Japanese", native: "日本語", flag: "🇯🇵" },
  zh: { label: "Chinese", native: "中文", flag: "🇨🇳" },
};
